const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar, // 此处有头部面包屑的头像
  infonum: state => state.user.infonum,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  ocurl: state => state.user.ocurl,
  Official: state => state.user.Official,
  ssourl:state => state.user.ssourl,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  channelId: state => state.user.channelId,
  applicationdata: state => state.user.applicationdata,
  channeldata: state => state.user.channeldata
}
export default getters
